import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=515629d3&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=515629d3&prod&lang=css"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=515629d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515629d3",
  null
  
)

export default component.exports